export default {
  sizes: {
    padding: 16,
    screenshotPreviewWidth: 108,
    screenshotWidth: 160,
    sessionStackedViewThreshold: 419,
    sessionCardMaxWidth: 598,
    sessionDetailsCardMaxWidth: 688,
    sidePanelWidth: 375,
    slideshowVerticalSidebarWidth: 205,
    slideshowHorizontalSidebarHeight: 110
  }
}
